import { takeLatest, put, call } from "redux-saga/effects";
import { GET_SETTING } from "./actionTypes";
import { getSettingFailed, getSettingSuccess } from "./actions";
import { getSettings } from "../../helpers/backend_helper";

function* onGetSetting({ payload: params }) {
  try {
    const response = yield call(getSettings, params);
    yield put(
      getSettingSuccess(response.registration ? response.registration[0] : {})
    );
  } catch (error) {
    console.log(error);
    yield put(getSettingFailed(error.response));
  }
}

function* SettingSaga() {
  yield takeLatest(GET_SETTING, onGetSetting);
}

export default SettingSaga;
